import React, { useRef, useEffect, useCallback, useState} from 'react';
import FakeSequencer from './FakeSequencer.js';
import {connect} from 'react-redux';
import '../../LandingParts.scss';
import {usePart} from './usePart.js';

const LandingPart2 = ({setPart, part}) => { 
    return (
        <div ref={part}>
          <div className="landing-part part-2">
            <div className="landing-column">
              <p>
                Workflows you already love. <br/>
                Packed with features you've always dreamed of.
              </p>
              <p>
                Zequencer let's you sequence sounds intuitively
                and with intention.
              </p>
              <p>
                Sculpt that <i>off the cuff</i> idea.
              </p>
            </div>
            <div className="landing-column">
              <div>
                <FakeSequencer/>
              </div>
              Generative MIDI effects and scripting capabilities
              let you morph patterns into everlasting compositions. 
            </div>
          </div>
          <div className="workflows">
            <img className="workflow-1" src="/workflow-1.gif"/>
            <img className="workflow-1" src="/workflow-2.gif"/>
          </div>
          <div className="workflows-container">
            <img className="workflow-2" src="/slicing-sounds.gif"/>
          </div>
          <div className="mission-subheader">
            <div>
              Work seamlessly between computers.
            </div>
            <div>
              Straight from your browser.
            </div>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPart2);
